var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-button-selectlanguage icon",class:_vm.className,on:{"click":_vm.Handle_OnClick}},[_c('img',{attrs:{"height":"30","width":"30","src":_vm.$asset('image/flag/' + _vm.$store.state.languageCode + '.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }